/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can/util/util';
import dayjs from 'dayjs';
import Component from 'can/component/component';
import FeedService from 'scripts/services/base-feed-service';
import template from './live-tv-schedule.stache';

const tvScheduleUrl = window.globalSettings.feeds.schedule.tvScheduleUrl;
const tvScheduleWithDateUrl =
    window.globalSettings.feeds.schedule.tvScheduleWithDateUrl;

Component.extend({
    tag: 'live-tv-schedule',
    template: template,
    viewModel: {
        tvScheduleUrl: tvScheduleUrl,
        getTime(date) {
            return dayjs(date).format('h:mm');
        },
        getMeridian(date) {
            return dayjs(date).format('a');
        },
    },
    events: {
        inserted(element) {
            this.viewModel.bind('scheduleDate', () => {
                this.initFeedService();
            });
        },
        initFeedService() {
            const scheduleDate = this.viewModel.attr('scheduleDate');
            let feedUrl = tvScheduleUrl;
            if (scheduleDate) {
                feedUrl = can.sub(tvScheduleWithDateUrl, {
                    date: scheduleDate,
                });
            }
            new FeedService({ feedUrl, fromCache: false, autoUpdate: false })
                .on('data', (type, data) => {
                    this.viewModel.attr('broadcasts', data.broadcasts);
                })
                .on('error', (error) => {
                    console.error(
                        'Error fetching live tv schedule data',
                        error,
                    );
                })
                .fetch({ date: scheduleDate });
        },
    },
});
